import { customization, template, view } from '@yola/ws-sdk';
import store from 'src/js/store';
import appendCustomSchemeStyles from './append-custom-scheme-styles';
import compileCustomSchemeTemplate from './compile-custom-scheme-template';
import getSelectorByGlobalId from './get-selector-by-global-id';
import constants from '../constants';

const { GLOBAL_HEADER_CODE } = constants;

const getPaletteElement = (state, parentNode) => {
  if (parentNode) {
    const selector = getSelectorByGlobalId(
      template.selectors.getVariableValueByPath(
        state,
        customization.constants.COLOR_PALETTE_VARIABLE
      ),
      GLOBAL_HEADER_CODE
    );

    return selector ? parentNode.querySelector(selector) : null;
  }

  const liveDocument = view.accessors.getLiveDocument();

  if (!liveDocument) return null;

  const selector = getSelectorByGlobalId(
    template.selectors.getVariableValueByPath(
      state,
      customization.constants.COLOR_PALETTE_VARIABLE
    ),
    GLOBAL_HEADER_CODE
  );

  return selector ? liveDocument.querySelector(selector) : null;
};

const appendCustomSchemeToPaletteElement = ({
  schemeId,
  variables,
  element = null,
  parentNode = null,
}) => {
  const state = store.getState();
  const customSchemeTemplate = customization.selectors.getCustomColorSchemeTemplate(state);

  if (!customSchemeTemplate) return null;

  const paletteElement = element || getPaletteElement(state, parentNode);

  if (!paletteElement) return null;

  const previousLastElementChild = paletteElement.lastElementChild;
  const compiledStyle = compileCustomSchemeTemplate(customSchemeTemplate, schemeId, variables);

  appendCustomSchemeStyles(paletteElement, compiledStyle);

  return {
    paletteElement,
    styleElement:
      paletteElement.lastElementChild !== previousLastElementChild
        ? paletteElement.lastElementChild
        : null,
  };
};

export default appendCustomSchemeToPaletteElement;
